import Navbar from '../assets/Navbar';
import CardDesign from '../components/cardDesign';
import FooterSection from 'assets/Footer';
import {useParams } from 'react-router-dom';
import TrendingProducts from 'components/dashboardComponents/trendingProducts';
import useGetSubCataloguesWithAllItem from 'hook/useGetSubCatalougesWithAllItem';
import NoDataView from "../components/noDataView";
import ScreenScrollToTop from "../components/ScreenScrollToTop";
import CardShimmer from "../components/shimmer/CardShimmer";
const SubCategoryWiseData = () => {
    const { subCatalogueId } = useParams();
    const { subGroupedAllData, loading, error } =
        useGetSubCataloguesWithAllItem(subCatalogueId);

    return (
        <div className='bg-gray-100 flex flex-col min-h-[100dvh]'>
            <Navbar />

            <div className="container mx-auto relative">

                {/* 🔄 Loading */}
                {loading && (
                    <CardShimmer count={8} />
                )}


                {/* 🚫 No Data */}
                {!loading && !error && subGroupedAllData.length === 0 && (
                    <NoDataView title="শীঘ্রই নতুন পণ্য যুক্ত করা হবে।"/>
                )}

                {/* ✅ Data */}
                {!loading && !error && subGroupedAllData.length > 0 && (
                    <>
                        <div className="flex items-center justify-center w-full px-4 md:my-5 mt-3">
                            <span className="md:text-2xl text-xl md:font-bold font-extrabold text-black tracking-wide pt-3 pb-1">
                                {subGroupedAllData[0]?.subCatalogue_title}
                            </span>
                        </div>

                        <CardDesign likeData={subGroupedAllData} />
                    </>
                )}
            </div>
            <TrendingProducts />
            <FooterSection />
            <ScreenScrollToTop />
        </div>
    );
};

export default SubCategoryWiseData;